<template>
    <div>
        <NotasHeaderMenu v-show="!visibleDetalhesAluno" :items="menuHeaderItems" />

        <NotasTableSkeleton v-if="carregandoNotas && alunosComAvaliacoes.length === 0" />
        <NotasTable v-else :alunosComAvaliacoes="alunosComAvaliacoes" :colunas="colunas" :tableHeight="tableHeight"
            :getSeverityFromNota="getSeverityFromNota" :mapearNotaParaCriterio="mapearNotaParaCriterio"
            :mesclarComentarios="mesclarComentarios" @cell-edit-complete="onCellEditComplete"
            @ver-detalhes-aluno="verDetalhesAluno" @context-menu="onCellContextMenu"
            @editar-avaliacao="avaliacaoSelecionadaParaEdicao" />

        <ComentarioDialog v-model:visible="visibleComentario" :header="tipoComentarioHeader"
            :tipoComentarioEstudante="tipoComentarioEstudante" :tipoComentarioGrupo="tipoComentarioGrupo"
            :tipoComentarioPorfessor="tipoComentarioPorfessor" v-model:comentario="comentario"
            v-model:comentarioGrupo="comentarioGrupo" v-model:comentario_para_estudante="comentario_para_estudante"
            @salvar="salvarComentario" @salvar-grupo="salvarComentarioParaOGrupo" />

        <SelecionarNotaDialog v-model:visible="visibleModalNotas" :header="nomeDoCriterioSendoAvaliado"
            v-model:modelValue="notaSelectNotas" :options="opcoesSelectNotas" @click="atualizarNota()" />

        <SelecionarGrupoDialog v-model:visible="visibleGrupos" v-model:modelValue="grupoSelecionado"
            :options="opcoesGrups" @salvar="atualizarSelecaoDeGrupo()" />

        <DefinirADDialog v-model:visible="visibleDefinirAD" v-model:modelValue="definirAdSelected" :options="colunas"
            :gerarNomeDefinirAD="gerarNomeDefinirAD" @salvar="definirADTodosEstudantes()" />

        <ContextMenu ref="menu" :model="menuItensNotas" />
        <ImportarNotasFormsVue v-if="isImportarNotasDialogVisible"
            v-model:visibleImportarNotas="importarNotasModalVisible"
            :avaliacoesComFormularios="avaliacoesComFormularios" :estudantes="alunosComAvaliacoes"
            @update:importarNotasModalVisible="updateImportarNotasModalVisible" />

        <Dialog ref="dialogDetalhesAluno" class="dialog-detalhes-aluno" maximizable v-if="detalhesDoAluno !== null"
            v-model:visible="visibleDetalhesAluno" modal :header="detalhesDoAluno.aluno.nome" :style="{ width: '50rem' }"
            :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <DetalhesDoAluno :data="detalhesDoAluno" />
        </Dialog>

        <SelecionarTrimestreDialog v-model:visible="visibleSelecionarTrimestre" v-model:modelValue="trimestreAtual"
            :options="trimestres" @salvar="alterarTrimestre()" />

    </div>
</template>

<script setup>

import { ref, onMounted, onBeforeUnmount, computed, watchEffect, nextTick } from 'vue';
import { useStore } from 'vuex';
import ContextMenu from 'primevue/contextmenu';
import Dialog from 'primevue/dialog';
import { supabase } from '@/supabase';
import ImportarNotasFormsVue from '@/components/professor/ImportarNotasForms.vue';
import calcularMediaParaAluno from "@/utils/calcularMediaPorAlunoPadrao";
import DetalhesDoAluno from '@/components/professor/Notas/DetalhesDoAluno.vue';
import { obterTrimestreAtual } from '@/utils/obterTrimestreAtual';
import { trimestres } from '@/store/dadosPadrao';
import NotasHeaderMenu from './notas/NotasHeaderMenu.vue';
import NotasTable from './notas/NotasTable.vue';
import NotasTableSkeleton from './notas/NotasTableSkeleton.vue';
import ComentarioDialog from './notas/ComentarioDialog.vue';
import SelecionarNotaDialog from './notas/SelecionarNotaDialog.vue';
import SelecionarGrupoDialog from './notas/SelecionarGrupoDialog.vue';
import DefinirADDialog from './notas/DefinirADDialog.vue';
import SelecionarTrimestreDialog from './notas/SelecionarTrimestreDialog.vue';

import CommentTextMultipleOutlineIcon from 'vue-material-design-icons/CommentTextMultipleOutline.vue'

onMounted(() => {
    carregarDados()
})
const detalhesDoAluno = ref(null)
const visibleDetalhesAluno = ref(false)
const dialogDetalhesAluno = ref()
const visibleComentario = ref(false);
const store = useStore();
const turma = computed(() => store.state.turma)
const notas = ref()
const alunosComAvaliacoes = ref([])
const colunas = ref([])
const avaliacoesComFormularios = ref([])
const opcoesGrups = ref([])
const grupoSelecionado = ref()
const jaSeleciouGrupo = ref(false)
const visibleModalNotas = ref(false)
const visibleGrupos = ref(false)
const visibleSelecionarTrimestre = ref(false)
const tableHeight = ref('auto')
const carregandoNotas = ref(false)
const isImportarNotasDialogVisible = ref(false) 
const importarNotasModalVisible = ref(false) 
const trimestreAtual = ref('1');
trimestreAtual.value = obterTrimestreAtual();
const nomeDoCriterioSendoAvaliado = ref('')
function verDetalhesAluno(data){
    visibleDetalhesAluno.value = true;
    detalhesDoAluno.value = {planos: colunas.value, aluno: data}

    nextTick(() => {
        if (dialogDetalhesAluno.value) {
            dialogDetalhesAluno.value.maximized = true
        }
    })
}


const menuHeaderItems = ref([
    { label: 'Escolher Grupo', icon: 'pi pi-users', command: () => selecionarGrupo() },
    { label: 'Escolher Trim.', icon: 'pi pi-calendar', command: () => visibleSelecionarTrimestre.value = true },
    { label: 'Importar Notas', icon: 'pi pi-upload', command: () => toggleImportarNotasDialog() },
    { label: 'Definir AD', icon: 'pi pi-check', command: () => definirAD() },
    { label: 'Exprotar conceitos', icon: 'pi pi-download', command: () => exportarDados()}
]);

function exportarDados(){
    const csvData =  [];
    notas.value.forEach(aluno => {
        const avaliacoesAluno = []
        aluno.avaliacoes.forEach(avaliacao => {
            avaliacoesAluno.push({
                conceito: mapearNotaParaNotacao(avaliacao),
                tituloAvalicao: getNomeAvaliacao(avaliacao)
            });
        })

        csvData.push({
            aluno: aluno.nome,
            avaliacoes: avaliacoesAluno
        })
    })

    gerarCSV(csvData);
}

function gerarCSV(dados) {
    // Inicializa o array de dados do CSV
    const csvData = [];

    // Extrai todos os títulos únicos de avaliações
    const titulosUnicos = new Set();
    dados.forEach(aluno => {
        aluno.avaliacoes.forEach(avaliacao => {
            titulosUnicos.add(avaliacao.tituloAvalicao.trim()); // Remove espaços extras e adiciona ao conjunto
        });
    });

    // Transforma o conjunto de títulos em um array ordenado
    const titulosOrdenados = Array.from(titulosUnicos).sort();

    // Cabeçalho do CSV: começa com "Aluno" e adiciona os títulos das avaliações
    const header = ["Aluno", ...titulosOrdenados];
    csvData.push(header);

    // Processa os dados dos alunos
    dados.forEach(aluno => {
        const row = [aluno.aluno]; // Começa a linha com o nome do aluno

        // Mapeia as avaliações do aluno para um objeto com base no título
        const avaliacoesPorTitulo = {};
        aluno.avaliacoes.forEach(avaliacao => {
            avaliacoesPorTitulo[avaliacao.tituloAvalicao.trim()] = avaliacao.conceito || ""; // Preenche com "" se o conceito for nulo
        });

        // Para cada título, adiciona o conceito correspondente (ou vazio se não houver)
        titulosOrdenados.forEach(titulo => {
            row.push(avaliacoesPorTitulo[titulo] || ""); // Adiciona o conceito ou "" se não existir
        });

        csvData.push(row); // Adiciona a linha ao CSV
    });

    // Função para converter array em CSV
    function arrayToCsv(data) {
        return data.map(row =>
            row.map(field => `"${field}"`).join(",") // Coloca aspas em cada campo e junta com vírgula
        ).join("\n"); // Junta as linhas com quebra de linha
    }

    // Gera o conteúdo CSV
    const csvContent = arrayToCsv(csvData);

    // Cria um link para download do arquivo CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${turma.value.nomeDaTurma}-avaliacoes.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function mapearNotaParaNotacao(avaliacao){
    if(avaliacao.tipo == '2'){
        return avaliacao.nota;
    }else {
        if (avaliacao.nota === 1) {
            return 'Não fez';
        } else if (avaliacao.nota === 201) {
            return 'Dispensado';
        } else if (avaliacao.nota === 202) {
            return 'Não avaliado';
        } else if (avaliacao.nota == 10) {
            return 'AB';
        } else if (avaliacao.nota == 60) {
            return 'B';
        } else if (avaliacao.nota == 90) {
            return 'AD';
        } else if (avaliacao.nota == 100) {
            return 'AV';
        } 
    }

    return '';
    
}

function getNomeAvaliacao(avaliacao){
    const resultado = colunas.value.find(item => item.id == avaliacao.id);
    if(!resultado) return 'Sem título';
    return `${resultado.titulo} - ${resultado.criterio} - ${resultado.titulo_avaliacao}`;
}   

const toggleImportarNotasDialog = () => {
  isImportarNotasDialogVisible.value = !isImportarNotasDialogVisible.value
  importarNotasModalVisible.value = !importarNotasModalVisible.value
}
const definirAD = () => {
    visibleDefinirAD.value = true
}
function definirADTodosEstudantes(){
    alunosComAvaliacoes.value.forEach(aluno => {
        aluno.avaliacoes.forEach(avaliacao => {
            if(avaliacao.id == definirAdSelected.value){
                avaliacao.nota = 90
                atualizarNotasDepoisDefinirAD(avaliacao.id, aluno.id)
            }
        })
    })
    definirAdSelected.value = ''
    visibleDefinirAD.value = false
}
async function atualizarNotasDepoisDefinirAD (avaliacao, estudante){
    const { data, error } = await supabase
        .from('planos_notas')
        .update({ nota: 90 })
        .eq('avaliacao', avaliacao )
        .eq('estudante', estudante)

    if (error) {
        alert('ocorreu um erro ao salvar'+error)
    }  
}
function gerarNomeDefinirAD(titulo, titulo_avaliacao, criterio){
    if(titulo_avaliacao == "" || titulo_avaliacao == null){
        return `${titulo} - ${criterio}`
    }else{
        return `${titulo} - ${titulo_avaliacao}`
    }
   
}
const visibleDefinirAD = ref(false)
const definirAdSelected = ref()

const updateImportarNotasModalVisible = (newValue) => {
isImportarNotasDialogVisible.value = newValue
  importarNotasModalVisible.value = newValue
}

function selecionarGrupo() {
    visibleGrupos.value = true
}

function alterarTrimestre(){
    listarNotas()
    visibleSelecionarTrimestre.value = false
}



async function carregarDados() {
    await listarNotas()
    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    await listarGrupos()
    await listarOpcoesGrupos()

}

async function listarGrupos() {
    const { data, error } = await supabase
        .from('grupos_selecionados_aulas')
        .select('idDoGrupo')
        .eq('idDaAula', turma.value.idDaAula)
        .order('idDoGrupo', { ascending: false })


    if (error) {
        alert('Ocorreu um erro ao carregar os grupos: ' + error.message)
        return
    } else if (data.length == 0) {
        return
    }

    grupoSelecionado.value = data[0].idDoGrupo
    jaSeleciouGrupo.value = true

    const { data: grupos, errorGrupos } = await supabase
        .from('grupos_estudantes')
        .select('numero_grupo, estudante')
        .eq('grupo', data[0].idDoGrupo)

    if (errorGrupos) {
        alert('Ocorreu um erro ao carregar os grupos: ' + errorGrupos.message)
        return
    }

    alunosComAvaliacoes.value.forEach(aluno => {
        grupos.forEach(estudanteId => {
            if (aluno.id == estudanteId.estudante) {
                aluno.grupo = estudanteId.numero_grupo
            }
        })
    })



}
async function listarOpcoesGrupos() {
    const { data, error } = await supabase
        .from('grupos')
        .select('*')
        .eq('idDaAula', turma.value.idDaAula)

    if (error) {
        alert('Ocorreu um erro ao carregar os grupos: ' + error.message)
        return
    }

    opcoesGrups.value = data
}
async function atualizarSelecaoDeGrupo() {
    if (jaSeleciouGrupo.value) {
        const { error } = await supabase
            .from('grupos_selecionados_aulas')
            .update({ idDoGrupo: grupoSelecionado.value })
            .eq('idDaAula', turma.value.idDaAula)

        if (error) {
            alert('Ocorreu um erro ao selecionar o grupo: ' + error.message)
            return
        }
        listarGrupos()
        visibleGrupos.value = false
    } else {
        // salvar
        const { error } = await supabase
            .from('grupos_selecionados_aulas')
            .insert({ idDaAula: turma.value.idDaAula, idDoGrupo: grupoSelecionado.value })

        if (error) {
            alert('Ocorreu um erro ao selecionar o grupo: ' + error.message)
            return
        }
        listarGrupos()
        visibleGrupos.value = false

    }
}
function calculateHeight() {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Subtrai 140px para telas menores que 'md' (768px) e 70px para telas maiores
    const subtractionValue = viewportWidth < 768 ? 120 : 61;
    const desiredHeight = viewportHeight - subtractionValue;

    tableHeight.value = `${desiredHeight}px`;
}


const onCellContextMenu = (event, estudanteData, avaliacaoData, comentarioData, comentario_grupoData, comentario_para_estudanteData) => {
    menu.value.show(event);
    estudante.value = estudanteData
    avaliacao.value = avaliacaoData
    comentario.value = comentarioData
    comentario_para_estudante.value = comentario_para_estudanteData
    comentarioGrupo.value = comentario_grupoData

    event.preventDefault();


};

function mesclarComentarios(comentario, comentarioGrupo, comentarioParaEstudante) {
    let resultado = ""
    if (comentario != "") {
        resultado = `Registro do professor \n ${comentario} \n\n`
    }

    if (comentarioGrupo != "") {
        resultado += `Registro sobre o grupo \n ${comentarioGrupo} \n\n`
    }

    if (comentarioParaEstudante != "") {
        resultado += `Comentário para o estudante \n ${comentarioParaEstudante} \n`
    }

    return resultado
}

const estudante = ref()
const avaliacao = ref()
const comentario = ref()
const comentario_para_estudante = ref()
const comentarioGrupo = ref()
let tipoComentarioHeader = ref()
let tipoComentarioPorfessor = ref()
let tipoComentarioGrupo = ref()
let tipoComentarioEstudante = ref()


const menu = ref()

const menuItensNotas = ref([
    { label: 'Professor', icon: 'pi pi-fw pi-comment', command: () => adicionarComentario('professor') },
    { label: 'Grupo', icon: 'pi pi-fw pi-users', command: () => adicionarComentario('grupo') },
    { label: 'Estudante', icon: 'pi pi-fw pi-comments', command: () => adicionarComentario('estudante') },
    { label: 'Liberar Forms', icon: 'pi pi-fw pi-key', command: () => liberarFormulario() },


]);

async function liberarFormulario() {
    const { error } = await supabase
        .from('planos_notas')
        .update({ avaliacao_forms_encerrada: null })
        .eq('estudante', estudante.value)
        .eq('avaliacao', avaliacao.value)

        if(error){
            alert('Ocorreu um erro ao liberar o formulario: ' + error.message)
        }else{
            alert('A avaliação foi liberada. Peça para o estudante recarregar a página para continuar com a avaliação.')
        }
}

async function adicionarComentario(tipo) {
   
    tipoComentarioPorfessor.value = false
    tipoComentarioGrupo.value = false
    tipoComentarioEstudante.value = false
    if (tipo == 'professor') {
        tipoComentarioHeader.value = "Registro do professor"
        tipoComentarioPorfessor.value = true
    } else if (tipo == 'grupo') {
        if (jaSeleciouGrupo.value == false) {
            alert('Selecione um grupo primeiro para depois poder adicionar comentários para o grupo. Clique com o botão direito do mouse em qualquer lugar da tela para fazer isso.')
            return
        }
        tipoComentarioHeader.value = "Registro para o grupo"
        tipoComentarioGrupo.value = true
    } else {
        tipoComentarioHeader.value = "Comentário para o estudante"
        tipoComentarioEstudante.value = true
    }
    visibleComentario.value = true

}
async function salvarComentario() {
    const alunoIndex = alunosComAvaliacoes.value.findIndex(aluno => aluno.id === estudante.value);
    if (alunoIndex !== -1) {
        const avaliacaoIndex = alunosComAvaliacoes.value[alunoIndex].avaliacoes.findIndex(aval => aval.id == avaliacao.value);
        if (avaliacaoIndex !== -1) {
            alunosComAvaliacoes.value[alunoIndex].avaliacoes[avaliacaoIndex].comentario = comentario.value;
            alunosComAvaliacoes.value[alunoIndex].avaliacoes[avaliacaoIndex].comentario_para_estudante = comentario_para_estudante.value;
        }

    }

    if (tipoComentarioPorfessor.value != '') {
        const { data, error } = await supabase
            .from('planos_notas')
            .update({ comentario: comentario.value })
            .eq('estudante', estudante.value)
            .eq('avaliacao', avaliacao.value)


    } else if (tipoComentarioEstudante.value != '') {
        const { data, error } = await supabase
            .from('planos_notas')
            .update({ comentario_para_estudante: comentario_para_estudante.value })
            .eq('estudante', estudante.value)
            .eq('avaliacao', avaliacao.value)

        if(error){
            alert('Ocorreu um erro ao salvar o comentário para o estudante: ' + error.message)
        }

    }


    visibleComentario.value = false


}

async function salvarComentarioParaOGrupo() {
    const alunoIndex = alunosComAvaliacoes.value.findIndex(aluno => aluno.id === estudante.value)
    const grupoIndex = alunosComAvaliacoes.value[alunoIndex].grupo
    

    if (alunoIndex !== -1) {
        const avaliacaoIndex = alunosComAvaliacoes.value[alunoIndex].avaliacoes.findIndex(aval => aval.id == avaliacao.value)
        if (avaliacaoIndex !== -1) {
            alunosComAvaliacoes.value.forEach(aluno => {

                if (aluno.grupo == grupoIndex) {
                    aluno.avaliacoes[avaliacaoIndex].comentario_grupo = comentarioGrupo.value
                    salvar(comentarioGrupo.value, aluno.avaliacoes[avaliacaoIndex].idNota)

                }
            })
        }

    }

    async function salvar(comentario, idNota) {
        const { data, error } = await supabase
            .from('planos_notas')
            .update({ comentario_grupo: comentario })
            .eq('id', idNota)


        if (error) {
            alert(error.message)
            return
        }
    }



    visibleComentario.value = false

}

function mapearNotaParaCriterio(nota, criterios) {
    if (nota >= 0) {
        for (let criterio of criterios) {
            if (criterio.valor == nota) {
                return criterio.nome;
            }
        }
    }
}



const listarNotas = async () => {
    carregandoNotas.value = true
    const { data, error } = await supabase
        .from('notas_detalhadas')
        .select('*')
        .eq('turma_id', turma.value.idDaTurma)
        .eq('trimestre', trimestreAtual.value)
        .eq('aula', turma.value.idDaAula)
        .order('aluno_nome', { ascending: true })
        .order('nota_id', { ascending: false });

    if (error) {
        carregandoNotas.value = false
        console.log(error)
        alert('Ocorreu um erro, recarregue a página')
        return;
    }

    const alunosMap = new Map()

    data.forEach(row => {
        if (!alunosMap.has(row.aluno_id)) {
            alunosMap.set(row.aluno_id, { id: row.aluno_id, nome: row.aluno_nome, img: row.aluno_img, media: 0, grupo: 0, avaliacoes: [] })
        }

        alunosMap.get(row.aluno_id).avaliacoes.push({
            id: row.avaliacao_id,
            idNota: row.nota_id,
            comentario: row.comentario,
            comentario_grupo: row.comentario_grupo,
            comentario_para_estudante: row.comentario_para_estudante,
            nota: row.nota,
            tipo: row.avaliacao_tipo,
            tipo_criterio: row.avaliacao_tipo === "1" ? row.criterio_id : null,
            titulo_avaliacao: row.avaliacao_titulo
        })
    })

    let array = Array.from(alunosMap.values())

    notas.value = array

    let avaliacoes = []
    let avaliacoesComFormulariosTemp = []

    data.forEach(row => {
        const avaliacaoExiste = avaliacoes.some(avaliacao => avaliacao.id === row.avaliacao_id);
        if (!avaliacaoExiste) {
            if (row.avaliacao_tipo == "1") {
                avaliacoes.push({
                    id: row.avaliacao_id,
                    criterios: [{ valor: 0, nome: "" }, { valor: 1, nome: "Não fez" }, { valor: 201, nome: "Dispensado" }, { valor: 202, nome: "Não avaliado" }, { valor: 10, nome: row.nivel1 }, { valor: 60, nome: row.nivel2 }, { valor: 90, nome: row.nivel3 }, { valor: 100, nome: row.nivel4 }],
                    titulo: row.plano_titulo,
                    titulo_avaliacao: row.avaliacao_titulo,
                    criterio: row.criterio_nome
                });
            } else {
                avaliacoes.push({
                    id: row.avaliacao_id,
                    titulo: row.plano_titulo,
                    criterio: "",
                    titulo_avaliacao: row.avaliacao_titulo,
                });
                avaliacoesComFormulariosTemp.push({
                    id: row.avaliacao_id,
                    titulo: row.plano_titulo,
                    criterio: "",
                    titulo_avaliacao: row.avaliacao_titulo,
                    forms_id: row.forms_id,
                    idQuestaoComNomes: row.id_questao_com_nomes
                })
            }
        }
    });

    avaliacoesComFormularios.value = avaliacoesComFormulariosTemp


    array = notas.value.map(aluno => {
        const avaliacoesAluno = {};

        aluno.avaliacoes.forEach(avaliacao => {
            // Criando uma chave dinâmica para cada avaliação
            avaliacoesAluno[`avaliacao_${avaliacao.id}`] = avaliacao;
        });

        return {
            ...aluno,
            ...avaliacoesAluno
        };
    });

    array.forEach(aluno => {
        aluno.media = calcularMediaParaAluno(aluno);
    });


    alunosComAvaliacoes.value = array


    
    colunas.value = avaliacoes
    carregandoNotas.value = false

}




function getSeverityFromNota(tipo, avaliacao) {

    if (avaliacao > 200) {
        return
    } else if (avaliacao > 95) {
        return "success";
    } else if (avaliacao >= 80) {
        return "info";
    } else if (avaliacao >= 60) {
        return "warning";
    } else if (avaliacao > 0)
        return "danger"

    else {
        return "neutral";
    }

}

const notaSelectNotas = ref(null);
const opcoesSelectNotas = ref();
const idNota = ref()
const alunoId = ref()
const avaliacaoId = ref()
const dataAtualizarNota = ref()


function avaliacaoSelecionadaParaEdicao(avaliacao, criterios, data) {
    nomeDoCriterioSendoAvaliado.value = avaliacao.titulo_avaliacao
    idNota.value = avaliacao.idNota
    alunoId.value = data.data.id
    avaliacaoId.value = data.field.replace("avaliacao_", "").replace(".nota", "")
    notaSelectNotas.value = avaliacao.nota
    opcoesSelectNotas.value = criterios
    visibleModalNotas.value = true
    dataAtualizarNota.value = data.data


}

async function atualizarNota() {
    const alunoIndex = alunosComAvaliacoes.value.findIndex(aluno => aluno.id === alunoId.value)

    if (alunoIndex !== -1) {
        const avaliacaoIndex = alunosComAvaliacoes.value[alunoIndex].avaliacoes.findIndex(avaliacao => avaliacao.id == avaliacaoId.value);
        if (avaliacaoIndex !== -1) {
            alunosComAvaliacoes.value[alunoIndex].avaliacoes[avaliacaoIndex].nota = notaSelectNotas.value;
        }

    }

    let resultado = calcularMediaParaAluno(dataAtualizarNota.value)

    alunosComAvaliacoes.value[alunoIndex].media = resultado
    visibleModalNotas.value = false

    const { data, error } = await supabase
        .from('planos_notas')
        .update({ nota: notaSelectNotas.value })
        .eq('id', idNota.value)

    if (error) {
        alert('ocorreu um erro ao salvar')
    }


}



async function onCellEditComplete(event) {
    const alunoId = event.data.id;
    let avaliacaoId = event.field.replace("avaliacao_", "").replace(".nota", "")
    avaliacaoId = parseInt(avaliacaoId, 10)
    const newValue = event.newValue;

    if (newValue == null) {
        return
    }

    const alunoIndex = alunosComAvaliacoes.value.findIndex(aluno => aluno.id === alunoId);
    if (alunoIndex !== -1) {
        const avaliacaoIndex = alunosComAvaliacoes.value[alunoIndex].avaliacoes.findIndex(avaliacao => avaliacao.id == avaliacaoId);
        if (avaliacaoIndex !== -1) {
            alunosComAvaliacoes.value[alunoIndex].avaliacoes[avaliacaoIndex].nota = newValue;
        }

    }

    const { data, error } = await supabase
        .from('planos_notas')
        .update({ nota: newValue })
        .eq('estudante', alunoId)
        .eq('avaliacao', avaliacaoId)

    if (error) {
        alert('ocorreu um erro ao salvar')
    }

    let resultado = calcularMediaParaAluno(event.data)


    alunosComAvaliacoes.value[alunoIndex].media = resultado

}



</script>


<style >
.area-comentario {
    margin-left: 74px;
    margin-bottom: -8px;




}

.p-tooltip-text {
    font-size: 10px;
}

.p-tooltip {
    max-width: 300px;
}

.input-table-notas .p-inputnumber-input {
    display: block;
    max-width: 85px;
    padding: 4px;

}


.select-table-notas {
    border: 0px;
    background-color: transparent;
}

.icone-comentario {
    padding: 5px;
    border-radius: 50%;
    height: 20px;
    width: 20px;

}
.icone-comentario-sem-nota {
     padding: 5px;
    height: 26px;
    width: 5rem;
}

.truncate {
    white-space: nowrap;
    /* Não permite quebras de linha */
    overflow: hidden;
    /* Esconde o conteúdo excedente */
    text-overflow: ellipsis;
    /* Mostra "..." quando o conteúdo é cortado */
    max-width: 150px;
    /* Define uma largura máxima para o contêiner */
}

.p-column-title {
    font-size: 14px !important;
    line-height: 16px !important;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;


    -webkit-line-clamp: 2;
    display: -webkit-box;

    -webkit-box-orient: vertical;
    overflow: hidden;

}



.truncate2 {
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 110px;


    -webkit-line-clamp: 2;
    display: -webkit-box;

    -webkit-box-orient: vertical;
    overflow: hidden;
    /* Define uma largura máxima para o contêiner */
}

select {
    max-width: 100%;
    border-radius: 5px;
    padding: 5px;
}

select:focus-visible {
    outline: none;
}

#select-notas .p-button {
    margin: 10px;
    display: inline-block;
    min-width: 100px;
    min-height: 40px;
    font-size: 13px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
}

#select-notas .p-button-label {
    font-weight: 500;
    display: block;
    text-align: left;
}
.dialog-detalhes-aluno .p-dialog-header-maximize {
    display: none;
}

.btn-opcoes-reader{
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1500;
    padding-top: 6px;
    padding-right: 6px;
}

</style>